<template>
  <div class="box7_main">
    <div class="title">报警信息</div>
    <div class="content">
      <ul class="con_head clearfix">
          <li>设备ID</li>
          <li>报警时间</li>
          <li>报警内容</li>
          <li>所属区域</li>
      </ul>
      <div class="messages">
        <div class="content-issue" v-if="itemData.length">
          <ul class="clearfix" v-for="(item, index) in itemData" :key="index">
            <li>{{item.id}}</li>
            <li>{{item.date}}</li>
            <li>{{item.content}}</li>
            <li>{{item.createdAt}}</li>
          </ul>
        </div>
        <div class="content-issue" v-else>
          <ul class="clearfix">
            <li style="width:90%;text-align:center">暂无报警信息</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Box7',
  props: {
    itemData: {
      type: Array,
      required: true,
      default: function () {
        return [

        ]
      }
    }
  },
  data() {
    return {
    }
  }
};
</script>
<style lang='less' scoped>
.box7_main {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-image:url('../../assets/home_images/box7/title_x.png');
  background-position:center top;
  background-repeat:no-repeat;
  .title {
    font-size: 16px;
    line-height:30px;
    width:100%;
    color:#d22e5f;
    padding-left:35px;
    box-sizing: border-box;
    background-image:url('../../assets/home_images/box7/title_x.png');
    background-position:center bottom;
    background-repeat:no-repeat;
  }
  .content{
    position: absolute;
    padding-top:30px;
    width:100%;
    height:100%;
    box-sizing: border-box;
    top:0;
    left:0;
    .con_head{
      width:100%;
      position:absolute;
      top:30px;
      left:0;
      list-style: none;
      margin:0;
      background-image:url('../../assets/home_images/box7/title_x.png');
      background-position:center bottom;
      background-repeat:no-repeat;
      padding:0 0 0 35px;
      box-sizing: border-box;
      height:26px;
      li{
        float: left;
        line-height:26px;
        color:#d22e5f;
        font-size:12px;
        text-align: center;
      }
      li:first-child{
        width:10%;
        text-align: left;
      }
      li:nth-child(2){
        width:35%;
      }
      li:nth-child(3){
        width:30%;
      }
      li:nth-child(4){
        width:25%;
      }
    }
    .messages {
      position: relative;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      overflow: hidden;
      padding-top: 28px;
      .content-issue{
        width: 100%;
        height: 100%;
        background-image:url('../../assets/home_images/box7/message_left.png');
        background-position:left center;
        background-repeat:no-repeat;
        padding-left: 35px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-evenly; /* 水平均匀分布 */
        align-items: center; /* 垂直居中 */
        flex-direction: column;
        ul{
          height:24px;
          cursor: pointer;
          list-style: none;
          margin:0;
          padding:0;
          width:100%;
          li{
            float: left;
            color:#cf2558;
            font-size:12px;
            text-align: center;
            height: 24px;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          li:first-child{
            width:10%;
            text-align: left;
            justify-content: flex-start; /* 水平居中 */
            box-sizing: border-box;
            padding-left: 10px;
          }
          li:nth-child(2){
            width:35%;
          }
          li:nth-child(3){
            width:30%;
            color:#ef1959;
          }
          li:nth-child(4){
            width:25%;
            font-size:10px;
            font-family: Arial, Helvetica, sans-serif;
          }
        }
        ul:hover li{
          color:#fff
        }
      }
    }
    .none_data{
      font-size:14px;
      color: #0e7ca7;
      width:100%;
      height:100%;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;     /* 垂直居中 */
      text-align:center;
    }
    
  }
  
}


</style>